import React from "react";
import styles from "./SliderButton.module.scss";

const SliderButton = (props) => {
  const onGoTo = (dir) => {
    const slider = props.slider?.current?.slider;
    if (!slider) return;
    slider.goTo(dir);
  };
  const imgSource = props.direction == "next" ? "./img/slide-arrow-next.svg" : "./img/slide-arrow-prev.svg";

  if (props.hidden) return null;

  return (
    <div
      className={[
        styles.button,
        styles[props.direction],
        props.dimmed ? styles.dimmed : "",
        props.compact ? styles.compact : "",
      ].join(" ")}
      onClick={() => onGoTo(`${props.direction.substring(0, 4)}`)}
    >
      <div className={[styles.arrowButtonWrapper, props.variant ? styles[`variant_${props.variant}`] : ""].join(" ")}>
        <div className={styles.arrowIconTrack}>
          <div className={styles.arrowIconExit}>
            <div className={styles.arrowIcon}>
              <img src={imgSource} alt={props.direction} />
            </div>
          </div>
          <div className={styles.arrowIconEnter}>
            <div className={styles.arrowIcon}>
              <img src={imgSource} alt="" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SliderControls = (props) => {
  return (
    <div className={"sliderControls"}>
      <SliderButton
        direction="previous"
        slider={props.slider}
        hidden={props.isFirst}
        dimmed={props.dimFirst}
        variant={props.variant}
        compact={props.compact}
      ></SliderButton>
      <SliderButton
        direction="next"
        slider={props.slider}
        hidden={props.isLast}
        dimmed={props.dimLast}
        variant={props.variant}
        compact={props.compact}
      ></SliderButton>
    </div>
  );
};

export default SliderControls;
